import { Popconfirm } from 'antd';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import { TableActions } from '~/components/Table';
import moment from 'moment';
import 'moment/locale/pt-br';
import Strong from '~/components/Strong';
import i18next from 'i18next';

export const extraExpensesColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:default.name')}:</Strong> {record.name}
            <br />
            <Strong>{i18next.t('screens:default.date')}:</Strong>{' '}
            {moment(record.acquired_at).locale('pt-br').format('DD/MM/YYYY')}
            <br />
            <Strong>{i18next.t('screens:default.price')}:</Strong>{' '}
            {Number(record.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@extraExpenses/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@extraExpenses/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => record.name,
    },
    {
      title: i18next.t('screens:default.date'),
      dataIndex: 'acquired_at',
      key: 'acquired_at',
      render: (text, record) => moment(record.acquired_at).locale('pt-br').format('DD/MM/YYYY'), //formatar data
    },
    {
      title: i18next.t('screens:default.price'),
      dataIndex: 'price',
      key: 'price',
      width: '300px',
      render: (text, record) => Number(record.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // converte para R$
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (text, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@extraExpenses/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@extraExpenses/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};
